var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxUpArrowAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34788 1.56096L0.663946 5.35774L1.4561 6.12635L5.14003 2.32957L5.19057 5.67974L6.29403 5.6631L6.21507 0.429089L0.981067 0.508043L0.997713 1.6115L4.34788 1.56096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxUpArrowAlt);
export default __webpack_public_path__ + "static/media/bx-up-arrow-alt.6e6d5153f3793c0572716a1c6acdc0bd.svg";
export { ForwardRef as ReactComponent };